import { useSearchParams } from 'react-router';
import {
  DEFAULT_IAP_PARAMS,
  IapParams,
  validateIapParams,
  validateIapParamsFromUrl,
} from 'utils/iapParamValidation';
import { decrementedParamsForCode } from '../utils/IapUtils';
import { useCurrentPeriod } from './incidentHooks';
import { useMemo } from 'react';

export const useIapParams = (incidentId: string): IapParams | undefined => {
  const [searchParams] = useSearchParams();
  const { periodNumber, currentPeriod } = useCurrentPeriod();

  return useMemo(() => {
    if (!incidentId) {
      return undefined;
    }

    const urlParams = validateIapParams(searchParams);
    if (urlParams) {
      return decrementedParamsForCode(urlParams);
    }

    const storageKey = `iap-dashboard-url-${incidentId}`;
    const storedUrl = localStorage.getItem(storageKey);
    if (storedUrl) {
      const storedParams = validateIapParamsFromUrl(storedUrl);
      if (storedParams) {
        return storedParams;
      }
    }

    return {
      ...DEFAULT_IAP_PARAMS,
      period: periodNumber,
      phase: currentPeriod?.phase_number_completed || 0,
    };
  }, [
    incidentId,
    searchParams,
    periodNumber,
    currentPeriod?.phase_number_completed,
  ]);
};
